import React from "react";
import Paper from "@/components/paper/Paper";
import DataMaskingParagraph from "@/components/dataMaskingParagraph/DataMaskingParagraph";
import { useTranslation } from "react-i18next";
import { IDataMaskingParagraphData } from "@/components/dataMaskingParagraph/IDataMaskingParagraph";

const CorporateFamily = (): JSX.Element => {
  const {t} = useTranslation();
  const properties: IDataMaskingParagraphData={
    maskHeadingLocalized: t("companyProfile.corporate.maskHeadingLocalized"),
    maskContentLocalized: t("companyProfile.corporate.maskContentLocalized"),
    hooversFreeTrialDirectoryPathRewritten: t("companyProfile.corporate.hooversFreeTrialDirectoryPathRewritten"),
    maskButtonLocalized: t("companyProfile.corporate.maskButtonLocalized")
  }
  return (<>
    <a className="anchor" data-name="corporate-family" href="/corporate-family"> <span className="display-hidden">Corporate Family</span> </a>
    <div className="corporationSection" id="corporate-family">
      <Paper title={t("companyProfile.corporate.corporateSectionTitle")}>
        <DataMaskingParagraph dataMasking={properties}></DataMaskingParagraph>
      </Paper>
    </div>
  </>)};
export default CorporateFamily;



